export default "__VITE_ASSET__Xluov533__"